import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class PriceInsertService {

	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	insertPrice(token, price: any) {
		console.log(price);
		

		
		
		
		
		
		
		

		return this.http
		.post(this.apiUrl + "price/v1/insertaverage", JSON.stringify(price), JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/price/service/price-insert/price-insert.service.ts